// Central mapping of script-text images — now using the cropped + transparent
// PNGs served from the backend. No mix-blend-mode hack, no margin tricks —
// these are tight transparent PNGs that drop in anywhere.

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const base = `${BACKEND}/api/script`;
// Bump this when the PNGs are regenerated to bust the browser cache.
const V = "v11";

export const SCRIPT_IMG = {
  welcome:        `${base}/welcome.png?${V}`,
  travel:         `${base}/travel.png?${V}`,
  localAccomm:    `${base}/local-accomm.png?${V}`,
  hotels:         `${base}/hotels.png?${V}`,
  airbnb:         `${base}/airbnb.png?${V}`,
  about:          `${base}/about.png?${V}`,
  weddingDay:     `${base}/wedding-day.png?${V}`,
  thankYou:       `${base}/thank-you.png?${V}`,
  questions:      `${base}/questions.png?${V}`,
  registry:       `${base}/registry.png?${V}`,
  couple:         `${base}/couple.png?${V}`,
  ceremony:       `${base}/ceremony.png?${V}`,
  dressCode:      `${base}/dress-code.png?${V}`,
  transportation: `${base}/transportation.png?${V}`,
};

// All script images render at the same physical height so a single-word
// heading ("Registry") and a long phrase ("Local Accommodation") share the
// same letter size. Width auto-scales from the PNG's intrinsic aspect ratio.
const DEFAULT_HEIGHT = "42px";

export function ScriptImage({ src, alt, className = "", height = DEFAULT_HEIGHT }) {
  return (
    <img
      src={src}
      alt={alt}
      className={`inline-block ${className}`}
      style={{
        height,
        width: "auto",
        maxWidth: "100%",
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
      }}
      data-testid={`script-img-${alt.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
    />
  );
}
